import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';
export const Card = ({ children, shadow = true, borderRadius, padding, background, style, className, onClick, 'data-testid': dataTestId, }) => {
    const theme = useTheme();
    const isInteractive = typeof onClick === 'function';
    const baseStyle = {
        background: background ?? theme.cardBackground ?? theme.background,
        borderRadius: borderRadius ?? theme.cardBorderRadius ?? 8,
        boxShadow: shadow ? (theme.cardBoxShadow ?? '0 2px 4px 0 rgba(0,0,0,0.12)') : undefined,
        padding: padding ?? theme.cardPadding ?? 36,
        position: 'relative',
        ...style,
    };
    if (isInteractive) {
        return (_jsx("button", { type: 'button', className: className, "data-testid": dataTestId, onClick: onClick, style: {
                ...baseStyle,
                border: 'none',
                cursor: 'pointer',
                textAlign: 'inherit',
            }, children: children }));
    }
    return (_jsx("div", { className: className, "data-testid": dataTestId, style: baseStyle, children: children }));
};
